/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import BuddibleSocket, { MsgIDList } from "../../lib/BuddibleSocket";
import Utilities from "../../lib/Utilities";
import CodeList from "../../lib/CodeList";

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

const COMP_GB_TYPE = {
  A: "화주",
  B: "포워더",
  C: "운송사",
  D: "보험사",
  E: "관세사",
  Z: "관리자",
};

let inviteBeforeUser = {};
const _mClassName = "LogiTalkUserList";

const logiworkAlarmTalkTest = {
  id: "433adc4a-8853-448f-bacf-61f0a2696946",
  cnmMainKey: "433adc4a-8853-448f-bacf-61f0a2696946",
  cnmType: "5",
  cnmSite: "Z0001",
  cnmCompNM: "(주)지비티에스",
  cnmTreeKey: "",
  cnmAllow: "",
  cnmKind: "",
  cnmPWD: "",
  cnmPicMain:
    "https://gbts-invoice.s3.ap-northeast-2.amazonaws.com/gbts/companyInfo/20240125142859_GBTS2.png?GBTS2.png",
  cnmName: "LOGIWORK 상태알림",
  cnmDesc: "GBTS에서 엄선한 하루 5개, 한 줄 뉴스를 매일 아침 전달 드립니다",
  cnmLastDelYN: "N",
  cnmLastMSG: "기분좋은 하루되세요^^",
  cnmLastTime: "2024-02-01 08:54:34",
  cnmLastUser: "hskim@bstc.kr",
  cnmLastUserSite: "E0001",
  cnmCreator: "hskim@gbts.co.kr",
  cnmCreatorSite: "Z0001",
  cnmCreatDate: "2024-01-16 09:46:06",
  cnmUpdateDate: "2024-02-01 08:54:34",
  cnmDelYN: "N",
  COMP_LOGO:
    "https://gbts-invoice.s3.ap-northeast-2.amazonaws.com/gbts/companyInfo/20240125142859_GBTS2.png?GBTS2.png",
  cnmSubscribe: "0",
  cnmUnreadCnt: "1",
  cniMainKey: "433adc4a-8853-448f-bacf-61f0a2696946",
  cniSites:
    "A0005|A0009|A0010|A0011|A0015|A0017|A0020|A0023|A0024|A0025|A0026|A0027|A0028|A0029|A0030|A0032|A0035|A0036|A0037|A0038|A0039|A003E|A003F|A003G|A003H|A003I|A003J|A003M|A003N|A003O|A003P|A003R|A003U|A003V|A003W|A003X|A003Z|A0040|A0041|A0042|A0043|A0044|A0045|A0046|A0047|A0048|A0049|A004A|A004B|A004C|A004D|A004E|A0050|A0051|A0052|A0053|A0054|A0055|A0056|A0057|A0058|A0059|A0061|A0062|A0063|A0064|A0065|A0066|A0067|A0068|A0070|A0071|A0072|A0073|A0074|A0075|A0076|A0077|A0078|A0079|A0080|A0081|A0082|A0083|A0084|A0085|A0086|A0087|A0088|A0089|A0090|A0091|A0092|A0093|A0094|A0095|A0096|A0097|A0098|A0099|A0100|A0101|A0106|A0108|A0109|A0111|A0112|A0114|A0115|A0116|A0117|A0118|A0119|A0121|A0122|A0123|A0124|A0125|A0126|A0127|A0128|A0129|A0130|A0131|A0132|A0133|A0134|A0135|A0136|A0137|A0138|A0139|A0141|A0142|A0143|A0144|A0145|A0146|A0147|A0148|A0149|A0150|A0151|A0152|A0153|A0154|A0155|A0156|A0157|A0158|A0159|A0160|A0161|A0162|A0163|A0164|A0165|A0166|A0167|A0168|A0169|A0170|A0171|A0172|A0173|A0174|A0175|A0176|A0177|A0178|A0179|A0180|A0181|A0182|A0183|A0184|A0185|A0186|A0188|A0189|A0190|A0191|A0192|A0193|A0194|A0195|A0196|A0197|A0198|A0199|A0200|A0201|A0202|A0203|A0204|A0205|A0206|A0207|A0208|A0209|A0210|A0211|A0212|A0213|A0214|A0215|A0216|A0217|A0218|A0219|A0220|A0221|A0222|A0223|A0224|A0225|A0226|A0227|A0228|A0229|A0230|A0231|A0232|A0233|A0234|A0235|A0236|A0237|A0238|A0239|A0240|A0241|A0242|A0243|A0244|A0245|A0246|A0247|A0248|A0249|A0250|A0251|A0252|A0253|A0254|A0255|A0256|A0257|A0258|A0259|A0260|A0261|A0262|A0263|A0264|A0265|A0266|A0267|A0268|A0269|A0270|A0271|A0272|A0273|A0274|A0276|A0277|A0278|A0279|A027A|A027B|A027C|A027D|A027E|A027F|A027G|A027H|A027I|A027J|A027K|A027L|A027M|A027N|A0288|A0289|A028A|A028B|A028I|A028J|A028L|A028M|A028N|A028O|A028P|A028Q|A028R|A028S|A028T|A028U|A028V|A028W|A028X|A028Y|A0299|A029A|A029B|A029C|A029D|A9100|A9900|B0004|B0005|B0006|B0007|B0008|B0009|B0010|B0015|B0016|B0017|B0019|B001D|B001E|B001F|B001G|B001H|B001I|B001J|B001K|B001L|B001N|B001P|B001Q|B001R|B001T|B001U|B001V|B001W|B001X|B001Y|B001Z|B0020|B0023|B0024|B0025|B0026|B0027|B0030|B0031|B0032|B0033|B0034|B0036|B0037|B0038|B0039|B003A|B003C|B003D|B003E|B003F|B003G|B003H|C0005|C0007|C0009|C0010|C0012|C002V|C002W|C002X|C002Y|D0006|D0010|E0001|E0002|E0003|E0004|E0005|F0007|F0008|F0009|F000C|F000E|F000G|F000H|F000I|Y0001|Z0001|A029E|B003I|B003J|A029F",
  cniCreator: "hskim@bstc.kr",
  cniCreatorSite: "E0001",
  cniCreatDate: "2024-01-16 09:46:24",
  cniUpdateDate: "2024-01-31 09:17:58",
  isEntire: true,
  LastTime: "2024-02-01 08:54:34",
};

export default function LogiTalkUserList(props) {
  const {
    loginInfo,
    isMobile,
    favUserList,
    newsChatList,
    openNewsChatRoom,
    favUserListDropDown,
    deleteFavUser,
    checkSelectedUserChat,
    CREATE_ROOM,
    EVENT_SOCKET_ROOM_INVITE,
    chatDataList,
    addActiveChRoom,
  } = props;

  const [searchWord, setSearchWord] = useState("");
  const [searchByUser, setSearchByUser] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);
  const [privateUserList, setPrivateUserList] = useState([]);
  const [crmType, setCrmType] = useState("");
  const [crmMainKey, setCrmMainKey] = useState("");
  const [isNewsListOpen, setIsNewsListOpen] = useState(true);

  let $search = useRef();
  let userData = {};

  (() => {
    socket.addLocalEventListener(
      MsgIDList.EVENT_TALK_ADD_CHAT_USER,
      _mClassName,
      (b, n) => {
        if (n) {
          let addUser = [];
          for (let key in n.chUserData) {
            addUser.push({
              USER_NICK: n.chUserData[key].UserNICK,
              COMP_NM: n.chUserData[key].UserCOMPNM,
              USER_NM: n.chUserData[key].UserName,
              USER_ID: n.chUserData[key].cruUserID,
              COMP_CD: n.chUserData[key].cruUserSite,
            });
          }

          inviteBeforeUser = n.chUserData;
          setCrmType(n.crmType);
          setCrmMainKey(n.crmMainKey);
          setSearchByUser(true);
          setPrivateUserList([...addUser]);
          setIsPrivate(true);
        }
      }
    );
  })();

  useEffect(() => {
    let addChatUser = socket.getLocalDataSet(
      MsgIDList.EVENT_TALK_ADD_CHAT_USER
    );
    if (addChatUser) {
      let addUser = [];
      for (let key in addChatUser.chUserData) {
        if (key !== userData.user_id) {
          addUser.push({
            USER_NICK: addChatUser.chUserData.UserNICK,
            COMP_NM: addChatUser.chUserData[key].UserCOMPNM,
            USER_NM: addChatUser.chUserData[key].UserName,
            USER_ID: addChatUser.chUserData[key].cruUserID,
            COMP_CD: addChatUser.chUserData[key].cruUserSite,
          });
        }
      }
      setCrmType(addChatUser.crmType);
      setCrmMainKey(addChatUser.crmMainKey);
      setSearchByUser(true);
      setPrivateUserList([...addUser]);
      setIsPrivate(true);
    }

    return () => {
      socket.removeLocalEventListener(
        MsgIDList.EVENT_TALK_ADD_CHAT_USER,
        _mClassName
      );
    };
  }, []);

  //나와의 채팅
  const SELF_CHAT = () => {
    let checkSelfTalk = chatDataList.findIndex(
      (item) =>
        item.crmMainKey ===
        `${loginInfo.comp_cd}_${loginInfo.user_id}|${loginInfo.comp_cd}_${loginInfo.user_id}`
    );
    if (checkSelfTalk < 0) {
      let selectUserList = [
        {
          cruUserSite: loginInfo.comp_cd,
          cruUserID: loginInfo.user_id,
        },
      ];
      CREATE_ROOM(selectUserList, 1);
    } else {
      addActiveChRoom(chatDataList[checkSelfTalk]);
    }
  };

  //단체 채팅방 생성 여부 확인
  const requestPrivateChatting = () => {
    codeList.Modal.current.confirm("단체 채팅방을 생성하시겠습니까?", (ret) => {
      if (ret) {
        setIsPrivate(ret);
        searchUserInputHandler(true);
      }
    });
  };

  //단체채팅방 유저 선택
  const selectedPrivateChUser = (user) => {
    let dataList = [...privateUserList];
    let setDataList = [];
    if (dataList.length) {
      for (let i = 0; i < dataList.length; i++) {
        if (
          dataList[i].COMP_CD !== user.COMP_CD ||
          dataList[i].USER_ID !== user.USER_ID
        ) {
          setDataList = [
            ...dataList,
            {
              ...user,
            },
          ];
        } else {
          dataList.splice(i, 1);
          setDataList = [...dataList];
        }
      }
    } else {
      setDataList = [{ ...user }];
    }
    setPrivateUserList([...setDataList]);
  };

  //단체 채팅방 생성
  const createPrivateChat = () => {
    let userList = [];
    let chatType = 1;
    for (let i = 0; i < privateUserList.length; i++) {
      if (privateUserList[i].USER_ID !== loginInfo.user_id) {
        userList.push({
          cruUserSite: privateUserList[i].COMP_CD,
          cruUserID: privateUserList[i].USER_ID,
        });
      }
    }
    if (userList.length > 1) {
      chatType = 2;
    }
    if (Number(crmType) !== 2 || !crmMainKey) {
      CREATE_ROOM(userList, chatType, searchUserInputHandler);
    } else {
      INVITE_USER();
    }
  };

  const INVITE_USER = () => {
    let invite = [];

    for (let i = 0; i < privateUserList.length; i++) {
      let key = `${privateUserList[i].COMP_CD}_${privateUserList[i].USER_ID}`;
      if (!inviteBeforeUser.hasOwnProperty(key)) {
        invite.push({
          cruUserSite: privateUserList[i].COMP_CD,
          cruUserID: privateUserList[i].USER_ID,
        });
      }
    }
    EVENT_SOCKET_ROOM_INVITE(invite, crmMainKey, searchUserInputHandler);
  };

  //유저 검색
  const searchByChatUser = () => {
    let search = $search.current.value;

    setSearchWord(search);
  };

  //검색 인풋 열기닫기
  const searchUserInputHandler = (val) => {
    if (val === undefined) val = !searchByUser;

    inviteBeforeUser = inviteBeforeUser;
    $search.current.value = "";
    setIsPrivate(val);
    setSearchByUser(!searchByUser);
    setSearchWord("");
    setPrivateUserList([]);
    setCrmType("");
    setCrmMainKey("");
  };

  const data = [...Object.values(favUserList)];

  return (
    <>
      <div
        className={`white_bg p-3 w-100 h-100 d-flex flex-column ${
          isMobile && isPrivate ? " position-fixed" : ""
        }`}
        style={{ zIndex: isMobile && isPrivate ? 99999 : "unset" }}
      >
        <div className="d-flex flex-row justify-content-between align-items-center">
          <h4 className="text-info py-2 mb-0">대화상대</h4>
          <div className="p-2 cursor_pointer">
            <i
              className="fas fa-users px-2"
              onClick={() => {
                requestPrivateChatting();
              }}
            />
            <i
              className={`${
                !searchByUser ? "fas fa-search" : "fas fa-times"
              } px-2`}
              onClick={() => searchUserInputHandler(false)}
            />
          </div>
        </div>

        <div className={`mb-3 ${searchByUser ? "d-flex " : "d-none"}`}>
          <input
            className="form-control rounded-pill"
            type="text"
            placeholder="아이디 또는 사용자명을 입력해 주세요"
            ref={$search}
            onChange={() => {
              searchByChatUser();
            }}
          />
        </div>

        <div className="flex-fill overflow_scroll scroll_hidden">
          <p className="p-0 m-0">{loginInfo.comp_nm}</p>
          <div
            className="d-flex flex-row justify-content-start align-items-center p-2 my-2 cursor_pointer"
            onClick={() => {
              SELF_CHAT();
            }}
          >
            <div
              className="border rounded-circle overflow-hidden mr-2"
              style={{
                background: `url(${
                  loginInfo.USER_PIC
                    ? loginInfo.USER_PIC
                    : "https://freiscop.gbts.co.kr/images/user_pic-50x50.png"
                }) 50% 50% / cover no-repeat`,
                width: 50,
                height: 50,
              }}
            />
            <div className="font-weight-bold">
              <div style={{ fontSize: "1.1em" }}>
                {loginInfo.USER_NICK}{" "}
                {loginInfo.USER_TEAM_NM ? `-${loginInfo.USER_TEAM_NM}` : ""}
              </div>
              <div className="text-secondary" style={{ fontSize: "0.8em" }}>
                {loginInfo.USER_PART_NM}
              </div>
            </div>
          </div>

          <div>
            <div className="p-2 mb-0  d-flex flex-row justify-content-between bg-freiscop-50 rounded text-white">
              <p>📢 알림톡</p>
              <div className="cursor_pointer px-2">
                {isNewsListOpen ? (
                  <i
                    className="fas fa-chevron-up"
                    onClick={() => {
                      setIsNewsListOpen(false);
                    }}
                  />
                ) : (
                  <i
                    className="fas fa-chevron-down"
                    onClick={() => {
                      setIsNewsListOpen(true);
                    }}
                  />
                )}
              </div>
            </div>
            <div className={`chUser ${isNewsListOpen ? "" : "disabled"}`}>
              <LogiworkAlarm item={logiworkAlarmTalkTest} />
              {newsChatList.map((item) => {
                return (
                  <NewsRoomItem
                    key={item.cnmMainKey}
                    item={item}
                    openNewsChatRoom={openNewsChatRoom}
                  />
                );
              })}
            </div>
          </div>

          {data.map((comp, i) => {
            const compKey = comp.COMP_CD + "_" + i;
            return (
              <CompItem
                key={compKey}
                comp={comp}
                i={i}
                searchWord={searchWord}
                favUserListDropDown={favUserListDropDown}
                isPrivate={isPrivate}
                selectedPrivateChUser={selectedPrivateChUser}
                checkSelectedUserChat={checkSelectedUserChat}
                deleteFavUser={deleteFavUser}
              />
            );
          })}
        </div>
        <div
          className={`border p-2 ${
            isMobile ? "mt-2" : "h-100 position-fixed"
          }  bg-white  ${isPrivate ? "d-block" : "d-none"}`}
          style={
            isMobile
              ? { marginBottom: 45 }
              : { top: 0, right: 0, zIndex: 9999, width: 400 }
          }
        >
          <h6 className="font-weight-bold text-secondary mb-2">
            단체 채팅생성
          </h6>
          <div
            className="overflow_scroll"
            style={isMobile ? { maxHeight: 100 } : {}}
          >
            {privateUserList.map((user, index) => {
              return (
                <div
                  key={`${user.COMP_CD}_${user.USER_ID}_${index}`}
                  className="border d-inline-block bg-light  p-2 rounded-pill mr-2 mb-2 cursor_pointer"
                  onClick={() => selectedPrivateChUser(user)}
                >
                  [{user.COMP_NM}] {user.USER_NICK}
                </div>
              );
            })}
            {privateUserList.length === 0 && (
              <div className="py-2">대화 유저를 선택 해 주세요.</div>
            )}
          </div>

          <div className="d-flex flex-row justify-content-end">
            <div
              className="btn_1 bg-secondary mr-2"
              onClick={() => {
                searchUserInputHandler(false);
              }}
            >
              취소
            </div>
            <div
              className="btn_1"
              onClick={() => {
                createPrivateChat();
              }}
            >
              확인
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const LogiworkAlarm = React.memo((props) => {
  const { item, openNewsChatRoom } = props;

  return (
    <div
      className="d-flex flex-row justify-content-start align-items-center cursor_pointer rounded-lg p-2 my-2 bg-blue-light"
      onClick={() => {
        codeList.Modal.current.alert("오픈준비중입니다.");
        // openNewsChatRoom(item)
      }}
    >
      <div className="rounded-circle overflow-hidden mr-2">
        <div
          style={{
            width: 50,
            height: 50,
            background: `url(https://gbts-invoice.s3.ap-northeast-2.amazonaws.com/talk/chatRoom/Z0001/amber.jung@buddible.com/20240201133843_logiwork_main_logo.png) #fff 50% 50%/contain no-repeat`,
          }}
        />
      </div>
      <div>
        <p className="font-weight-bolder" style={{ fontSize: "1.1em" }}>
          [OPEN 예정] {item.cnmName}
        </p>
        <p className="font-size-08">{item.cnmCompNM}</p>
      </div>
    </div>
  );
});

const NewsRoomItem = React.memo((props) => {
  const { item, openNewsChatRoom } = props;

  const logo =
    item.cnmPicMain !== ""
      ? item.cnmPicMain.split("?")[0]
      : "https://freiscop.gbts.co.kr/images/user_pic-50x50.png";

  return (
    <div
      className="d-flex flex-row justify-content-start align-items-center cursor_pointer rounded-lg p-2 my-2 bg-light"
      onClick={() => openNewsChatRoom(item)}
    >
      <div className="rounded-circle overflow-hidden mr-2">
        <div
          style={{
            width: 50,
            height: 50,
            background: `url(${logo}) #fff 50% 50%/contain no-repeat`,
          }}
        />
      </div>
      <div>
        <p className="font-weight-bold" style={{ fontSize: "1.1em" }}>
          {item.cnmName}
        </p>
        <p className="font-size-08">{item.cnmCompNM}</p>
      </div>
    </div>
  );
});

const CompItem = (props) => {
  const {
    comp,
    i,
    searchWord,
    favUserListDropDown,
    isPrivate,
    selectedPrivateChUser,
    checkSelectedUserChat,
    deleteFavUser,
  } = props;
  const compKey = comp.COMP_CD + "_" + i;

  const data = [...Object.values(comp.userList)];

  return (
    <div key={compKey}>
      <div className="p-2 mb-0 d-flex flex-row justify-content-between">
        <div className="text-secondary">
          [{COMP_GB_TYPE[comp.COMP_GB]}] {comp.COMP_NM}
        </div>
        <div className="cursor_pointer px-2">
          {comp.activeState ? (
            <i
              className="fas fa-chevron-up"
              onClick={() => {
                favUserListDropDown(comp.COMP_CD, false);
              }}
            />
          ) : (
            <i
              className="fas fa-chevron-down"
              onClick={() => {
                favUserListDropDown(comp.COMP_CD, true);
              }}
            />
          )}
        </div>
      </div>

      <div className={`chUser ${comp.activeState ? "" : "disabled"}`}>
        {data.map((user, index) => {
          if (
            !(
              user.USER_NICK.indexOf(searchWord) > -1 ||
              user.USER_ID.indexOf(searchWord) > -1
            )
          ) {
            return null;
          }

          const userKey =
            compKey + "_" + user.COMP_CD + "_" + user.USER_ID + "_" + index;
          return (
            <UserItem
              key={userKey}
              compKey={compKey}
              comp={comp}
              user={user}
              index={index}
              isPrivate={isPrivate}
              selectedPrivateChUser={selectedPrivateChUser}
              checkSelectedUserChat={checkSelectedUserChat}
              deleteFavUser={deleteFavUser}
            />
          );
        })}
      </div>
    </div>
  );
};
const UserItem = (props) => {
  const {
    comp,
    user,
    isPrivate,
    selectedPrivateChUser,
    checkSelectedUserChat,
    deleteFavUser,
  } = props;

  let isOff = user.IS_OFF === "Y";
  let isTimeOn = user.IS_TIME_ON === "Y";
  let isOffTime = false;

  let TIME_START = user.TIME_START;
  let TIME_END = user.TIME_END;

  if (isTimeOn && TIME_START && TIME_END) {
    let date = new Date();
    let hour = date.getHours();
    let min = date.getMinutes();
    let sec = date.getSeconds();

    if (min < 10) min = "0" + min;
    if (sec < 10) sec = "0" + sec;

    let currentTime = `${hour}${min}${sec}`;

    currentTime = Number(currentTime);

    TIME_START = TIME_START.split(":").join("");
    TIME_START = Number(TIME_START);
    TIME_END = TIME_END.split(":").join("");
    TIME_END = Number(TIME_END);

    if (currentTime <= TIME_START || currentTime >= TIME_END) {
      isOffTime = true;
    }
  }

  return (
    <div className="d-flex flex-row justify-content-between align-items-center cursor_pointer rounded-lg p-2 my-2 bg-light">
      <div
        className="d-flex flex-row justify-content-start align-items-center flex-fill"
        onClick={() => {
          if (user.USE_GB === "D") return;
          if (isPrivate) {
            selectedPrivateChUser(user);
          } else {
            checkSelectedUserChat(comp, user);
          }
        }}
      >
        <div className=" mr-2 position-relative">
          <div className="rounded-circle overflow-hidden">
            <div
              style={{
                width: 50,
                height: 50,
                background: `url(${
                  user.USER_PIC
                    ? user.USER_PIC
                    : "https://freiscop.gbts.co.kr/images/user_pic-50x50.png"
                }) #fff 50% 50%/cover no-repeat`,
              }}
            />
          </div>

          <div
            className={`position-absolute bg-light text-secondary border flex-row justify-content-center align-items-center rounded-circle ${
              isOff || isOffTime ? "d-flex" : "d-none"
            }`}
            style={{
              top: 0,
              left: 0,
              width: 16,
              height: 16,
            }}
          >
            <span className="font-size-06">
              <i className="fa-solid fa-bell-slash" />
            </span>
          </div>
          <div
            className={`position-absolute bg-info rounded-circle ${
              !(isOff || isOffTime) && user.login_state ? "" : "d-none"
            }`}
            style={{
              top: 3,
              left: 3,
              width: 10,
              height: 10,
            }}
          />
        </div>
        <div className="font-weight-bold">
          <div style={{ fontSize: "1.1em" }}>
            {user.USE_GB === "D" && (
              <span className="bg-danger text-white mr-1 px-2 rounded-pill">
                탈퇴
              </span>
            )}
            {user.USER_NICK || user.USER_NM}{" "}
            {user.USER_TEAM_NM ? `-${user.USER_TEAM_NM}` : ""}
          </div>
          <div className="text-secondary font-size-08">{user.USER_PART_NM}</div>
        </div>
      </div>
      <div
        className="align-self-end text-secondary cursor_pointer mr-2"
        onClick={() => deleteFavUser(user)}
      >
        삭제
      </div>
    </div>
  );
};
